export default __webpack_public_path__ + "static/media/Gilroy-Bold.901a60fc.ttf";